import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-green-700 text-white py-8">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Company Info */}
        <div>
          <h2 className="text-xl font-bold mb-4">Tirumala CoCo Peat</h2>
          <p className="text-gray-300">
            Your trusted partner in high-quality coco peat and coir products. We
            are committed to sustainable practices and eco-friendly solutions.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h2 className="text-xl font-bold mb-4">Quick Links</h2>
          <ul className="space-y-2">
            <li>
              <a href="/" className="hover:text-gray-200">
                Home
              </a>
            </li>
            <li>
              <a href="/company" className="hover:text-gray-200">
                Company
              </a>
            </li>
            <li>
              <a href="/products" className="hover:text-gray-200">
                Products
              </a>
            </li>
            <li>
              <a href="/manufacturing" className="hover:text-gray-200">
                Manufacturing
              </a>
            </li>
            <li>
              <a href="/contact-info" className="hover:text-gray-200">
                Contact Info
              </a>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h2 className="text-2xl font-bold mb-4">Contact Info</h2>
          <ul className="space-y-4 text-gray-300">
            <li className="flex items-center">
              <FaPhoneAlt className="mr-3" />
              <a
                href="tel:+919492228585"
                className="hover:underline hover:text-white"
              >
                +91 9492228585
              </a>
            </li>
            <li className="flex items-center">
              <FaPhoneAlt className="mr-3" />
              <a
                href="tel:+919441330442"
                className="hover:underline hover:text-white"
              >
                +91 9441330442
              </a>
            </li>
            <li className="flex items-center">
              <FaEnvelope className="mr-3" />
              <a
                href="mailto:mramana918@gmail.com"
                className="hover:underline hover:text-white"
              >
                mramana918@gmail.com
              </a>
            </li>
            <li className="leading-relaxed">
              Tirumala CoCo Peat, Mudigallu circle, Anantapur-Bypass Road, <br />
              Kalyanadurgam-515761, Anantapur (dist), <br />
              Andhra Pradesh, India
            </li>
          </ul>
        </div>

        {/* Social Media */}
        <div>
          <h2 className="text-xl font-bold mb-4">Follow Us</h2>
          <div className="flex space-x-4 text-gray-300">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              <FaTwitter />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              <FaInstagram />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-600 mt-8 pt-4 text-center text-gray-300">
        &copy; {new Date().getFullYear()} Tirumala CocoPeat Products. All rights
        reserved.
      </div>
    </footer>
  );
};

export default Footer;
